

import * as proxy from "fe2/proxy/supply";
import { getCurrentBase, getCurrentClan } from "helpers/currentAccount";
import { showMonumentAchievementsDialog } from "helpers/dialog";
import { fetchWrapper as fetch } from "helpers/fetch";
import { BUILDING_TYPES } from "helpers/supply";
import L from "leaflet";
import get from "lodash/get";
import { push } from "react-router-redux";
import { batchActions } from "redux-batched-actions";
import { ClanBaseCameraPos, ClanBaseSoundObjectPos, playCloseDialogSound, playOpenDialogSound, SupplyNotifications } from "web2ClientAPI/web2ClientAPI";
import { updateBlurBgMap } from "../utils/mapUtils";
import * as web2ClientAPI from "../web2ClientAPI/web2ClientAPI";
import { syncAccountInfo } from "./ActionAccount";
import { decreaseClanResource, fetchClan, increaseMaxClanSize } from "./ActionClanProfile";
import dwhExport from '~/dwhExport'

require('leaflet.sync');

export type IMap = null | L.Map;

let Map: IMap = null;
let MapBg = null;
let isSynced = false;
const settings = get(window.__PRELOADED_STATE__, 'settings', null);
const currentAccount = get(window.__PRELOADED_STATE__, 'currentAccount', null);

export const START_FETCHING = 'SUPPLY_START_FETCHING';
export const startFetching = clanId => ({
  type: START_FETCHING,
  clanId
});

export const STOP_FETCHING = 'SUPPLY_STOP_FETCHING';
export const stopFetching = clanId => ({
  type: STOP_FETCHING,
  clanId
});

export const UPDATE_BASE = 'SUPPLY_UPDATE_BASE';
export const updateBase = (clanId, base) => {
  return {
    type: UPDATE_BASE,
    clanId,
    base
  };
};

const getSoundPositions = buildings => {
  const soundPositions = [];
  if (!buildings) {
    return soundPositions;
  }

  for (const key in buildings) {
    if (buildings.hasOwnProperty(key)) {
      let coords = buildings[key].markerPosition;

      if (!coords) {
        coords = [-100, -100];
        console.error('didn`t get buildings coordinates');
      }

      soundPositions.push({
        name: key,
        x: coords[1].toFixed(5),
        y: coords[0].toFixed(5)
      });
    }
  }

  return soundPositions;
};

// TODO: use layerOrder
const layersOrder = {
  vessels: 100,
  ships: 90,
  steel_yard: 80,
  coal_yard: 70,
  dry_dock: 60,
  university: 50,
  design_department: 40,
  shipbuilding_factory: 30,
  treasury: 20,
  headquarters: 20,
  academy: 10,
  monument: 5,
  paragon_yard: 0,
}
export const DropSync = () => (dispatch: Dispatch, getState: GetState) => {
  isSynced = false;
};

export type UPDATE_SUPPLY_DATA_TYPE = "UPDATE_SUPPLY_DATA";
export const UPDATE_SUPPLY_DATA: UPDATE_SUPPLY_DATA_TYPE = 'UPDATE_SUPPLY_DATA';
export const UpdateSupplyData = (clanId: any, info: any) => (dispatch: Dispatch, getState: GetState) => {

  if (settings && currentAccount) {
    const supplyPreloaded = settings.supply;
    const userRole = currentAccount.roleName;
    const tilingServiceHost = get(supplyPreloaded, 'tilingServiceHost', '');
    const tilesLocalPath = get(supplyPreloaded, 'tilesLocalPath', '');
    const tileUrlTemplate = get(supplyPreloaded, 'tileUrlTemplate', null);
    const maxZoom = get(supplyPreloaded, 'maxZoom', 7);
    const minZoom = get(supplyPreloaded, 'minZoom', 5);

    if (supplyPreloaded) {
      const buildings = supplyPreloaded.buildings;
      let data = {};
      if (buildings && buildings.length) {
        buildings.forEach((item) => {
          const markerPosition = (item.levels && item.levels[0] && item.levels[0].markerPosition) ? item.levels[0].markerPosition : null

          data[item.name] = {
            ...item,
            level: get(info, [`${item.name}`, 'level'], 0),
            sort: get(info, [`${item.name}`, 'sort'], 0),
            modifiers: get(info, [`${item.name}`, 'modifiers'], []),
            markerPosition: markerPosition,
            order: layersOrder[item.name],
            type: item.type
          }
        })
      }

      const isInGame = window.navigator.userAgent.indexOf(settings.ingameUserAgent) !== -1;

      dispatch({
        type: UPDATE_SUPPLY_DATA,
        payload: {
          buildings: data,
          userRole,
          tilingServiceHost: isInGame ? tilesLocalPath : tilingServiceHost,
          tileUrlTemplate,
          maxZoom,
          minZoom
        }
      });
      dispatch(UpdateMinZoom());
      dispatch(InitSounds())
    }
  }
};

export type SET_MAP_REF_TYPE = "SET_MAP_REF";
export const SET_MAP_REF: SET_MAP_REF_TYPE = 'SET_MAP_REF';
export const SetMapRef = (ref: any) => (dispatch: Dispatch, getState: GetState) => {
  if (ref && ref.leafletElement) {
    Map = ref.leafletElement;
    if (Map && MapBg && !isSynced) {
      if (Map !== null) {
        Map.sync(MapBg);
        isSynced = true;
      }

    }
  }
};

export type SET_MAP_REF_BG_TYPE = "SET_MAP_REF_BG";
export const SET_MAP_REF_BG: SET_MAP_REF_BG_TYPE = 'SET_MAP_REF_BG';
export const SetMapRefBg = (ref: any) => (dispatch: Dispatch, getState: GetState) => {
  if (ref && ref.leafletElement) {
    MapBg = ref.leafletElement;
  }
};

export type SET_MAP_BLUR_TYPE = "SET_MAP_BLUR";
export const SET_MAP_BLUR: SET_MAP_BLUR_TYPE = 'SET_MAP_BLUR';
export const SetMapBlur = (isMapBlured: boolean) => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: SET_MAP_BLUR,
    payload: {
      isMapBlured: isMapBlured
    }
  });
};

export type SET_SELECTED_BUILDING_TYPE = "SET_SELECTED_BUILDING";
export const SET_SELECTED_BUILDING: SET_SELECTED_BUILDING_TYPE = 'SET_SELECTED_BUILDING';
export const SetSelectedBuilding = (buildingId: string | null, needSavePosition?: boolean) => (dispatch: Dispatch, getState: GetState) => {
  const state = getState();

  if (buildingId) {
    if (buildingId !== state.ReducerSupply.selectedBuildingId) {
      playOpenDialogSound();
      if (needSavePosition !== null && needSavePosition !== undefined && needSavePosition === true) {
        dispatch(SaveMapPosition());
      }
      dispatch(OpenSupplySideBar());
      dispatch(NavigateToBuilding(buildingId));
      dispatch({
        type: SET_SELECTED_BUILDING,
        payload: {
          buildingId: buildingId
        }
      });
      const newState = getState();
      setTimeout(() => {
        dispatch(SetHighlightedBuilding(null));
      }, newState.ReducerSupply.highlightDelay);
    }
  } else {
    playCloseDialogSound();
    dispatch(NavigateToPrevPosition());
    dispatch({
      type: SET_SELECTED_BUILDING,
      payload: {
        buildingId: buildingId
      }
    });
    dispatch(CloseSupplySideBar());
  }
};

export type SAVE_MAP_POSITION_TYPE = "SAVE_MAP_POSITION";
export const SAVE_MAP_POSITION: SAVE_MAP_POSITION_TYPE = 'SAVE_MAP_POSITION';
export const SaveMapPosition = () => (dispatch: Dispatch, getState: GetState) => {
  if (Map !== null) {
    const bounds = Map.getBounds();
    dispatch({
      type: SAVE_MAP_POSITION,
      payload: {
        bounds: bounds
      }
    });
  }
};

export type NAVIGATE_TO_BUILDING_TYPE = "NAVIGATE_TO_BUILDING";
export const NAVIGATE_TO_BUILDING: NAVIGATE_TO_BUILDING_TYPE = 'NAVIGATE_TO_BUILDING';
export const NavigateToBuilding = (buildingId: string) => (dispatch: Dispatch, getState: GetState) => {
  if (window.tooltipProvider) {
    window.tooltipProvider.hide(true);
  }
  const state = getState();
  if (Map !== null) {
    const level = state.ReducerSupply.buildings[buildingId].level;
    const geo = state.ReducerSupply.buildings[buildingId].levels[level].geo.contour;
    if (geo) {
      const polygon = L.polygon(geo);
      const polyBounds = polygon.getBounds();

      if (state.ReducerSupply.isSidebarOpened) {
        Map.fitBounds(polyBounds, { animate: false, paddingTopLeft: [200, 150], paddingBottomRight: [500, 150] });
      } else {
        Map.fitBounds(polyBounds, { animate: false, paddingTopLeft: [200, 150], paddingBottomRight: [200, 150] });
      }
    }
    Map.dragging.disable();
    Map.scrollWheelZoom.disable();
  }
};

export type NAVIGATE_TO_PREV_POSITION_TYPE = "NAVIGATE_TO_PREV_POSITION";
export const NAVIGATE_TO_PREV_POSITION: NAVIGATE_TO_PREV_POSITION_TYPE = 'NAVIGATE_TO_PREV_POSITION';
export const NavigateToPrevPosition = () => (dispatch: Dispatch, getState: GetState) => {
  const state = getState();
  if (Map !== null) {
    const bounds = state.ReducerSupply.prevPosition;
    Map.dragging.enable();
    Map.scrollWheelZoom.enable();
    if (bounds) {
      Map.fitBounds(bounds, { animate: false });
    }
  }
};

export type SET_HIGHLIGHTED_BUILDING_TYPE = "SET_HIGHLIGHTED_BUILDING";
export const SET_HIGHLIGHTED_BUILDING: SET_HIGHLIGHTED_BUILDING_TYPE = 'SET_HIGHLIGHTED_BUILDING';
export const SetHighlightedBuilding = (buildingId: string | null) => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: SET_HIGHLIGHTED_BUILDING,
    payload: {
      buildingId: buildingId
    }
  });
};

export type TURN_PHOTO_MODE_ON_TYPE = "TURN_PHOTO_MODE_ON";
export const TURN_PHOTO_MODE_ON: TURN_PHOTO_MODE_ON_TYPE = 'TURN_PHOTO_MODE_ON';
export const TurnPhotoModeOn = () => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: TURN_PHOTO_MODE_ON
  });
};

export type TURN_PHOTO_MODE_OFF_TYPE = "TURN_PHOTO_MODE_OFF";
export const TURN_PHOTO_MODE_OFF: TURN_PHOTO_MODE_OFF_TYPE = 'TURN_PHOTO_MODE_OFF';
export const TurnPhotoModeOff = () => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: TURN_PHOTO_MODE_OFF
  });
};

export type SET_MAP_ZOOM_TYPE = "SET_MAP_ZOOM";
export const SET_MAP_ZOOM: SET_MAP_ZOOM_TYPE = 'SET_MAP_ZOOM';
export const SetMapZoom = (zoom: number) => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: SET_MAP_ZOOM,
    payload: {
      zoom: zoom
    }
  });
};


export type INCREASE_BUILDING_LEVEL_TYPE = "INCREASE_BUILDING_LEVEL";
export const INCREASE_BUILDING_LEVEL: INCREASE_BUILDING_LEVEL_TYPE = 'INCREASE_BUILDING_LEVEL';
export const IncreaseBuildingLevel = (buildingId: string) => (dispatch: Dispatch, getState: GetState) => {
  dispatch(HideBuildConfirmDialog());
  const state = getState();
  const clanId = state.currentAccount.clanId;
  const newLevel = state.ReducerSupply.buildings[buildingId].level + 1;
  const url = state.urls.upgradeBuilding.replace('{clan_id}', `${clanId}`)
  if (newLevel <= state.ReducerSupply.buildings[buildingId].maxLevel) {
    dispatch(SetBuildingInProgress(buildingId));
    const options = {
      method: 'POST',
      body: {
        type: buildingId,
        level: newLevel
      }
    }
    return fetch(url, options).then(json => {
      if (json && json.building && json.building.level) {
        dispatch(SetBuildingLevel(buildingId, json.building.level));
        dispatch(SendBuildingUpgradeNotification(buildingId));
        dispatch(syncAccountInfo());
        dispatch(fetchClan(clanId, false))
      } else {
        dispatch(SendBuildingUpgradeNotification());
      }
    }).catch(err => {
      dispatch(UpgradeBuildingError(err));
      dispatch(SendBuildingUpgradeNotification());
    });
  }

};

export type SEND_BUILDING_UPGRADE_NOTIFICATION_TYPE = "SEND_BUILDING_UPGRADE_NOTIFICATION";
export const SEND_BUILDING_UPGRADE_NOTIFICATION: SEND_BUILDING_UPGRADE_NOTIFICATION_TYPE = 'SEND_BUILDING_UPGRADE_NOTIFICATION';
export const SendBuildingUpgradeNotification = (buildingId?: string) => (dispatch: Dispatch, getState: GetState) => {
  if (buildingId) {
    const state = getState();
    const building = state.ReducerSupply.buildings[buildingId];
    if (building) {
      const meta = building.levels[building.level].meta;
      SupplyNotifications.sendBuildSuccessNotification({
        title: building.levels[building.level].title,
        message: meta.bonus,
        cost: meta.cost,
        level: building.level,
        maxLevel: building.maxLevel
      });
    }
  }
};

export type UPGRADE_BUILDING_ERROR_TYPE = "UPGRADE_BUILDING_ERROR";
export const UPGRADE_BUILDING_ERROR: UPGRADE_BUILDING_ERROR_TYPE = 'UPGRADE_BUILDING_ERROR';
export const UpgradeBuildingError = (err: any) => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: UPGRADE_BUILDING_ERROR
  });
};
export type SET_BUILDING_IN_PROGRESS_TYPE = "SET_BUILDING_IN_PROGRESS";
export const SET_BUILDING_IN_PROGRESS: SET_BUILDING_IN_PROGRESS_TYPE = 'SET_BUILDING_IN_PROGRESS';
export const SetBuildingInProgress = (buildingId: string) => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: SET_BUILDING_IN_PROGRESS,
    payload: {
      buildingId: buildingId
    }
  });
};

export type SET_TEMP_HOVER_BUILDING_LEVEL_TYPE = "SET_TEMP_HOVER_BUILDING_LEVEL";
export const SET_TEMP_HOVER_BUILDING_LEVEL: SET_TEMP_HOVER_BUILDING_LEVEL_TYPE = 'SET_TEMP_HOVER_BUILDING_LEVEL';
export const SetTempHoverBuildingLevel = (buildingId: string, level: number) => (dispatch: Dispatch, getState: GetState) => {

  dispatch({
    type: SET_TEMP_HOVER_BUILDING_LEVEL,
    payload: {
      level: level,
      buildingId: buildingId
    }
  });
};

export type DROP_TEMP_HOVER_BUILDING_LEVEL_TYPE = "DROP_TEMP_HOVER_BUILDING_LEVEL";
export const DROP_TEMP_HOVER_BUILDING_LEVEL: DROP_TEMP_HOVER_BUILDING_LEVEL_TYPE = 'DROP_TEMP_HOVER_BUILDING_LEVEL';
export const DropTempHoverBuildingLevel = (buildingId: string) => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: DROP_TEMP_HOVER_BUILDING_LEVEL
  });
};

export type SET_BUILDING_LEVEL_TYPE = "SET_BUILDING_LEVEL";
export const SET_BUILDING_LEVEL: SET_BUILDING_LEVEL_TYPE = 'SET_BUILDING_LEVEL';
export const SetBuildingLevel = (buildingId: string, level: number) => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: SET_BUILDING_LEVEL,
    payload: {
      buildingId: buildingId,
      level: level
    }
  });
  dispatch(HideBuildingConfirm());
};

export type SHOW_BUILD_CONFIRM_DIALOG_TYPE = "SHOW_BUILD_CONFIRM_DIALOG";
export const SHOW_BUILD_CONFIRM_DIALOG: SHOW_BUILD_CONFIRM_DIALOG_TYPE = 'SHOW_BUILD_CONFIRM_DIALOG';
export const ShowBuildConfirmDialog = (buildingId: string) => (dispatch: Dispatch, getState: GetState) => {
  dispatch(DropTempHoverBuildingLevel(buildingId));
  const state = getState();
  const building = state.ReducerSupply.buildings[buildingId];
  let previewLevel = building.level < building.maxLevel ? building.level + 1 : building.level;
  dispatch({
    type: SHOW_BUILD_CONFIRM_DIALOG,
    payload: {
      buildingId: buildingId,
      previewLevel: previewLevel
    }
  });
};

export type HIDE_BUILD_CONFIRM_DIALOG_TYPE = "HIDE_BUILD_CONFIRM_DIALOG";
export const HIDE_BUILD_CONFIRM_DIALOG: HIDE_BUILD_CONFIRM_DIALOG_TYPE = 'HIDE_BUILD_CONFIRM_DIALOG';
export const HideBuildConfirmDialog = () => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: HIDE_BUILD_CONFIRM_DIALOG
  });
};

export type OPEN_SUPPLY_SIDEBAR_TYPE = "OPEN_SUPPLY_SIDEBAR";
export const OPEN_SUPPLY_SIDEBAR: OPEN_SUPPLY_SIDEBAR_TYPE = 'OPEN_SUPPLY_SIDEBAR';
export const OpenSupplySideBar = () => (dispatch: Dispatch, getState: GetState) => {
  const state = getState();
  dispatch({
    type: OPEN_SUPPLY_SIDEBAR
  });
  updateBlurBgMap(400);
  if (state.ReducerSupply.selectedBuildingId) {
    dispatch(NavigateToBuilding(state.ReducerSupply.selectedBuildingId));
  }
};

export type CLOSE_SUPPLY_SIDEBAR_TYPE = "CLOSE_SUPPLY_SIDEBAR";
export const CLOSE_SUPPLY_SIDEBAR: CLOSE_SUPPLY_SIDEBAR_TYPE = 'CLOSE_SUPPLY_SIDEBAR';
export const CloseSupplySideBar = () => (dispatch: Dispatch, getState: GetState) => {
  const state = getState();
  dispatch({
    type: CLOSE_SUPPLY_SIDEBAR
  });

  if (state.ReducerSupply.selectedBuildingId) {
    dispatch(SetSelectedBuilding(null));
    dispatch(HideBuildingConfirm());
  }
};

export type SHOW_BUILDING_CONFIRM_TYPE = "SHOW_BUILDING_CONFIRM";
export const SHOW_BUILDING_CONFIRM: SHOW_BUILDING_CONFIRM_TYPE = 'SHOW_BUILDING_CONFIRM';
export const ShowBuildingConfirm = (buildingId: string) => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: SHOW_BUILDING_CONFIRM,
    payload: {
      buildingId: buildingId
    }
  });
};

export type HIDE_BUILDING_CONFIRM_TYPE = "HIDE_BUILDING_CONFIRM";
export const HIDE_BUILDING_CONFIRM: HIDE_BUILDING_CONFIRM_TYPE = 'HIDE_BUILDING_CONFIRM';
export const HideBuildingConfirm = () => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: HIDE_BUILDING_CONFIRM
  });
};

export const OWN_BASE_ACTIONS = ['open_treasury'];

export type SELECT_BUILDING_TYPE = "SELECT_BUILDING";
export const SELECT_BUILDING: SELECT_BUILDING_TYPE = 'SELECT_BUILDING';
export const SelectBuilding = (buildingId: string, clanId: number, needSavePosition?: boolean) => (dispatch: Dispatch, getState: GetState) => {
  const state = getState();
  const isMyClan = state.currentAccount.clanId === clanId;
  const currentBuilding = state.ReducerSupply.buildings[buildingId];
  if (buildingId && isMyClan) {
    dwhExport.send('supply.view_building', {
      building_id: buildingId
    })
  }
  if (currentBuilding) {
    if (currentBuilding.levels[currentBuilding.level].action) {
      if (OWN_BASE_ACTIONS.indexOf(currentBuilding.levels[currentBuilding.level].action) !== -1) {
        if (isMyClan) {
          dispatch(BuildingClickAction(currentBuilding.levels[currentBuilding.level].action, clanId));
        } else {
          dispatch(SetSelectedBuilding(buildingId, needSavePosition));
        }
      } else {
        dispatch(BuildingClickAction(currentBuilding.levels[currentBuilding.level].action, clanId));
      }
    } else {
      dispatch(SetSelectedBuilding(buildingId, needSavePosition));
    }
  }
};

export type IBuildingClickAction = "show_achievements";
export type BUILDING_CLICK_ACTION_TYPE = "BUILDING_CLICK_ACTION";
export const BUILDING_CLICK_ACTION: BUILDING_CLICK_ACTION_TYPE = 'BUILDING_CLICK_ACTION';
export const BuildingClickAction = (action: IBuildingClickAction, clanId: number) => (dispatch: Dispatch, getState: GetState) => {
  const state = getState();

  switch (action) {
    case 'show_achievements':
      {
        dispatch(showMonumentAchievementsDialog(clanId));
        break;
      }
    case 'open_treasury':
      {
        dispatch(push(`${state.urls.root}treasury`));
        break;
      }
    default:
      {
        break;
      }

  }
};

export type NAVIGATE_TO_TREASURY_TYPE = 'NAVIGATE_TO_TREASURY'
export const NAVIGATE_TO_TREASURY: NAVIGATE_TO_TREASURY_TYPE = 'NAVIGATE_TO_TREASURY'
export const navigateToTreasury = (tab: string = 'regularRewards') => (dispatch: Dispatch, getState: GetState) => {
  const state = getState()
  dispatch(push(`${state.urls.root}treasury/${tab}`))
}

export type UPDATE_SOUND_POSITION_TYPE = "UPDATE_SOUND_POSITION";
export const UPDATE_SOUND_POSITION: UPDATE_SOUND_POSITION_TYPE = 'UPDATE_SOUND_POSITION';
export const UpdateSoundPosition = () => (dispatch: Dispatch, getState: GetState) => {
  if (Map !== null) {
    const position = Map.getCenter();
    const soundParams = {
      x: position.lng,
      y: position.lat,
      z: Map.getZoom()
    };
    ClanBaseCameraPos(soundParams);
  }
};

export type SYNC_SUPPLY_TYPE = "SYNC_SUPPLY_ACTION";
export const SYNC_SUPPLY: SYNC_SUPPLY_TYPE = 'SYNC_SUPPLY_ACTION';
export const SyncSupply = (json: any) => (dispatch: Dispatch, getState: GetState) => {
  const roleName = json.role_name;
  dispatch({
    type: SYNC_SUPPLY,
    payload: {
      role: roleName
    }
  });
};

export type INIT_SOUNDS_TYPE = "INIT_SOUNDS_ACTION";
export const INIT_SOUNDS: INIT_SOUNDS_TYPE = 'INIT_SOUNDS_ACTION';
export const InitSounds = () => (dispatch: Dispatch, getState: GetState) => {
  const state = getState();
  const buildings = state.ReducerSupply.buildings;
  ClanBaseSoundObjectPos(getSoundPositions(buildings));
};

export type UPDATE_MIN_ZOOM_TYPE = "UPDATE_MIN_ZOOM_ACTION";
export const UPDATE_MIN_ZOOM: UPDATE_MIN_ZOOM_TYPE = 'UPDATE_MIN_ZOOM_ACTION';
export const UpdateMinZoom = () => (dispatch: Dispatch, getState: GetState) => {
  const state = getState();
  const minZoom = state.ReducerSupply.minZoom;
  const newMinZoom = window.innerWidth > 1920 ? 6 : 5;

  if (newMinZoom !== minZoom) {
    dispatch({
      type: UPDATE_MIN_ZOOM,
      payload: {
        minZoom: newMinZoom
      }
    });
  }
};


export type SET_BACKGROUND_URL_TYPE = "SET_BACKGROUND_URL_ACTION";
export const SET_BACKGROUND_URL: SET_BACKGROUND_URL_TYPE = 'SET_BACKGROUND_URL_ACTION';
export const SetBackgroundUrl = (backgroundUrl: string) => (dispatch: Dispatch, getState: GetState) => {
  dispatch({
    type: SET_BACKGROUND_URL,
    payload: {
      backgroundUrl
    }
  });
};

export const BUILDING_UPDATED = 'SUPPLY_BUILDING_UPDATED';
export const bonusActivated = (clanId, buildingType, buildingId, modifier) => ({
  type: BUILDING_UPDATED,
  clanId,
  buildingType,
  buildingId,
  modifiers: [modifier]
});

const successNotifications = {
  [BUILDING_TYPES.NAVY_YARD]: web2ClientAPI.supply.sendNavyYardBonusActivated,
  [BUILDING_TYPES.DRY_DOCK]: web2ClientAPI.supply.sendDryDockBonusActivated,
  [BUILDING_TYPES.ENGINEERING]: web2ClientAPI.supply.sendEngineeringBonusActivated,
  [BUILDING_TYPES.BARRACKS]: web2ClientAPI.supply.sendBarracksBonusActivated,
  [BUILDING_TYPES.MONUMENT]: web2ClientAPI.supply.sendMonumentCreatedNotification
};

export const activateBonus = (buildingType, modifier) => {
  return (dispatch, getState) => {
    const state = getState();
    const url = state.urls.activateBonus;
    const clanId = state.currentAccount.clanId;
    const building = getCurrentBase(state)[buildingType];
    const buildingId = building && building.id;
    dispatch(startFetching(clanId));
    return proxy.activateBonus(url, clanId, modifier.id, buildingId).then(building => {
      let actions = [bonusActivated(clanId, buildingType, building.id, modifier.id), decreaseClanResource(clanId, modifier.cost)];
      const sendNotification = successNotifications[buildingType];
      sendNotification(modifier);
      if (modifier.name === 'members_count') {
        actions = [...actions, increaseMaxClanSize(clanId, modifier.value)];
      }
      dispatch(batchActions(actions));
    }, reason => {
      dispatch(stopFetching(clanId));
      web2ClientAPI.supply.sendActivateBonusErrorNotification(reason, { clan: getCurrentClan(state) });
      return Promise.reject();
    });
  };
};

export const SHOW_EDGES = 'SHOW_EDGES'
export const showEdges = (buildingId) => {
  return {
    type: SHOW_EDGES,
    payload: {
      buildingId
    }
  }
}
export const HIDE_EDGES = 'HIDE_EDGES'
export const hideEdges = (buildingId) => {
  return {
    type: HIDE_EDGES,
    payload: {
      buildingId
    }
  }
}